import { useCallback } from 'react';
import { Message } from '../../../types/chat';
import { SSEData } from '../../../services/chatService';

interface UseSSEMessageHandlerProps {
    setMessages: React.Dispatch<React.SetStateAction<Message[]>>;
    currentAssistantMessage: React.RefObject<string>;
}

export const useSSEMessageHandler = ({
    setMessages,
    currentAssistantMessage,
}: UseSSEMessageHandlerProps) => {
    const handleUIMessage = useCallback((data: SSEData, tempAssistantMessageId: string) => {
        setMessages(prev => prev.map(msg =>
            msg.id === tempAssistantMessageId || msg.id === data.id
                ? {
                    ...msg,
                    type: 'ui',
                    ui_type: data.ui_type!,
                    ui_data: data.ui_data,
                    text: '',
                    id: data.id
                }
                : msg
        ));
    }, [setMessages]);

    const handleTextMessage = useCallback((data: SSEData, tempAssistantMessageId: string) => {
        if (!data.content) return;
        
        currentAssistantMessage.current += data.content;
        setMessages(prev => prev.map(msg =>
            msg.id === tempAssistantMessageId || msg.id === data.id
                ? {
                    ...msg,
                    text: currentAssistantMessage.current,
                    type: 'text',
                    id: data.id
                }
                : msg
        ));
    }, [setMessages, currentAssistantMessage]);

    const handleMessage = useCallback((event: MessageEvent, tempAssistantMessageId: string) => {
        try {
            const data: SSEData = JSON.parse(event.data);
            if (data.type === 'ui') {
                handleUIMessage(data, tempAssistantMessageId);
            } else if (data.content) {
                handleTextMessage(data, tempAssistantMessageId);
            }
            return data.type;
        } catch (error) {
            console.error('解析SSE消息失败:', error);
            return null;
        }
    }, [handleUIMessage, handleTextMessage]);

    return { handleMessage };
}; 